import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reset dello scroll in cima a ogni cambio di rotta. In una SPA il browser non
 * resetta la posizione: navigando dal footer si atterrava a fondo pagina. Salta
 * il reset quando l'URL ha un hash (link ad àncora interni).
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
